import React from 'react';

import { Channel, ChannelProps } from '../../home/components/Channel';
import { ChannelStyles } from '../../home/styles/ChannelStyles';
import { ChannelTypes } from '../../home/types/ChannelTypes';
import { Starter, StartersGroupedByConnectionType } from '../types/StartersTypes';
import { StartersCard } from './StartersCard';

export interface StartersCardChannelOwnProps {
  readonly maxCardsPerRow: number;
  readonly startersGroupedByConnectionType?: StartersGroupedByConnectionType;
  readonly moreLikeThisLink?: string;
}

export interface StarterCardChannelDispatchProps {
  fetchStartersData?: () => void;
}

export type StarterCardChannelProps = ChannelProps & StarterCardChannelDispatchProps & StartersCardChannelOwnProps;

export class StarterCardChannel extends React.PureComponent<StarterCardChannelProps> {

  constructor(props: StarterCardChannelProps) {
    super(props);
  }

  public componentDidMount(): void {
    if (this.props.channelType === ChannelTypes.starters){
      this.props.fetchStartersData();
    }
  }

  render() {
    const maxNumCards = this.props.maxCardsPerRow * this.props.numRows;
    let cards = this.props.list.slice(0, maxNumCards).map((starter: Starter) => {
      return <React.Fragment key={`${starter.id}`}>
        <div className={ChannelStyles.cardDimensions}>
          <StartersCard
            starter={starter}
            startersGroupedByConnectionType={this.props.startersGroupedByConnectionType[starter.connectionType.internalName]}
            moreLikeThisLink={this.props.moreLikeThisLink}
            testId={`starters-card-${starter.connectionType.internalName}`}
          />
        </div>
      </React.Fragment>;
    });

    if (cards){
      return (
        <Channel {...this.props}>{cards}</Channel>
      );
    }
  }
}
